module.exports = __webpack_public_path__ + "static/illustrationAPI@2x-b5163b11f97a19635c1f89711abdc806.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/developers/illustrationAPI@2x.png
// module id = 2556
// module chunks = 168707334958949